// src/services/categoryApi.js
// Servicio para manejar operaciones relacionadas con categorías

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista todas las categorías (sin filtro)
 * @returns {Promise<Object>} Lista de categorías
 */
export const getCategories = async () => {
  try {
    const response = await dotoniwoofApi.get('/category.php');
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener categorías:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Lista categorías por tipo
 * @param {number} type - ID del tipo de categoría
 * @returns {Promise<Object>} Lista de categorías del tipo especificado
 */
export const getCategoriesByType = async (type) => {
  try {
    const response = await dotoniwoofApi.get(`/category.php?type=${type}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener categorías por tipo:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene una categoría por ID
 * @param {number} categoryId - ID de la categoría
 * @returns {Promise<Object>} Datos de la categoría
 */
export const getCategoryById = async (categoryId) => {
  try {
    const response = await dotoniwoofApi.get(`/category.php/${categoryId}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener categoría:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crea una nueva categoría
 * @param {Object} categoryData - Datos de la categoría
 * @param {string} categoryData.firebase_UID - UID de Firebase del usuario
 * @param {number} categoryData.id_category_type - ID del tipo de categoría
 * @param {string} categoryData.categoryName - Nombre de la categoría
 * @returns {Promise<Object>} Respuesta de la API
 */
export const createCategory = async (categoryData) => {
  try {
    const response = await dotoniwoofApi.post('/category.php', categoryData);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear categoría:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza una categoría existente
 * @param {number} categoryId - ID de la categoría
 * @param {Object} categoryData - Nuevos datos de la categoría
 * @param {string} [categoryData.categoryName] - Nombre de la categoría (opcional)
 * @param {number} [categoryData.id_category_type] - ID del tipo de categoría (opcional)
 * @param {number} [categoryData.profit] - Utilidad en porcentaje (opcional)
 * @returns {Promise<Object>} Respuesta de la API
 */
export const updateCategory = async (categoryId, categoryData) => {
  try {
    const response = await dotoniwoofApi.put(`/category.php/${categoryId}`, categoryData);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar categoría:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina una categoría
 * @param {number} categoryId - ID de la categoría
 * @returns {Promise<Object>} Respuesta de la API
 */
export const deleteCategory = async (categoryId) => {
  try {
    const response = await dotoniwoofApi.delete(`/category.php/${categoryId}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar categoría:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
